export const bacteriaLayoutConfig_allergy_eng = [
    {
        label: 'Candida albicans',
        page: 12,
        yOffset: 226,
        xLabel: 70,
        xBarStart: 298,
        xBarGap: 53,
        xResult: 685,
        yLabel: 218,
        yResult: 218,
        yResulttext: 222,
        xResulttext: 570,  
        show_result: true
    },
    {
        label: 'Escherichia coli',
        page: 12,
        yOffset: 262,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 254,
        yResult: 254,
        yResulttext: 258,
        xResulttext: 570,  
        show_result: true
    },
    {
        label: 'Ruminococcus bromii',
        page: 12,
        yOffset: 467,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 459,
        yResult: 459,
        yResulttext: 463,
        xResulttext: 570,  
        show_result: true
    },
    {
        label: 'Staphylococcus aureus',
        page: 12,
        yOffset: 302,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 294,
        yResult: 294,
        yResulttext: 298,
        xResulttext: 570,  
        show_result: true
    },
    {
        label: 'Akkermansia muciniphila',
        page: 12,
        yOffset: 387,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 379,
        yResult: 379,
        yResulttext: 383,
        xResulttext: 570,  
        show_result: true
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 12,
        yOffset: 427,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 419,
        yResult: 419,
        yResulttext: 423,
        xResulttext: 570,  
        show_result: true
    },
    {
        label: 'Bifidobacterium bifidum',
        page: 12,
        yOffset: 556,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 548,
        yResult: 548,
        yResulttext: 552,
        xResulttext: 570,  
        show_result: true
    },
    {
        label: 'Bifidobacterium lactis',
        page: 12,
        yOffset: 596,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 588,
        yResult: 588,
        yResulttext: 592,
        xResulttext: 570,  
        show_result: true
    },
    {
        label: 'Lactobacillus acidophilus',
        page: 12,
        yOffset: 636,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 628,
        yResult: 628,
        yResulttext: 632,
        xResulttext: 570,  
        show_result: true
    },
    {
        label: 'Lactobacillus rhamnosus',
        page: 12,
        yOffset: 676,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 668,
        yResult: 668,
        yResulttext: 672,
        xResulttext: 570,  
        show_result: true
    },
    {
        label: 'Lactobacillus reuteri',
        page: 12,
        yOffset: 716,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 708,
        yResult: 708,
        yResulttext: 712,
        xResulttext: 570,  
        show_result: true
    },
    {
        label: 'Candida albicans',
        page: 16,
        yOffset: 136,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 128,
        yResult: 128,
        yResulttext: 132,
        xResulttext: 570,  
        show_result: false
    },
    {
        label: 'Escherichia coli',
        page: 16,
        yOffset: 324,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 318,
        yResult: 318,
        yResulttext: 322,
        xResulttext: 570,  
        show_result: false
    },
    {
        label: 'Ruminococcus bromii',
        page: 17,
        yOffset: 616,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 610,
        yResult: 610,
        yResulttext: 614,
        xResulttext: 570,  
        show_result: false
    },
    {
        label: 'Staphylococcus aureus',
        page: 16,
        yOffset: 518,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 512,
        yResult: 512,
        yResulttext: 516,
        xResulttext: 570,  
        show_result: false
    },
    {
        label: 'Akkermansia muciniphila',
        page: 17,
        yOffset: 138,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 130,
        yResult: 130,
        yResulttext: 134,
        xResulttext: 570,  
        show_result: false
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 17,
        yOffset: 322,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 316,
        yResult: 316,
        yResulttext: 320,
        xResulttext: 570,  
        show_result: false
    },
    {
        label: 'Bifidobacterium bifidum',
        page: 18,
        yOffset: 138,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 130,
        yResult: 130,
        yResulttext: 134,
        xResulttext: 570,  
        show_result: false
    },
    {
        label: 'Bifidobacterium lactis',
        page: 18,
        yOffset: 280,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 274,
        yResult: 274,
        yResulttext: 278,
        xResulttext: 570,  
        show_result: false
    },
    {
        label: 'Lactobacillus acidophilus',
        page: 18,
        yOffset: 496,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 490,
        yResult: 490,
        yResulttext: 494,
        xResulttext: 570,  
        show_result: false
    },
    {
        label: 'Lactobacillus rhamnosus',
        page: 18,
        yOffset: 689,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 683,
        yResult: 683,
        yResulttext: 687,
        xResulttext: 570,  
        show_result: false
    },
    {
        label: 'Lactobacillus reuteri',
        page: 18,
        yOffset: 948,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 942,
        yResult: 942,
        yResulttext: 946,
        xResulttext: 570,  
        show_result: false
    },
];

export const bacteriaLayoutConfig_allergy_thai = [
    {
        label: 'Candida albicans',
        page: 11,
        yOffset: 226,
        xLabel: 70,
        xBarStart: 298,
        xBarGap: 53,
        xResult: 685,
        yLabel: 218,
        yResult: 218,
        yResulttext: 222,
        xResulttext: 570,  
        show_result: true
    },
    {
        label: 'Escherichia coli',
        page: 11,
        yOffset: 262,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 254,
        yResult: 254,
        yResulttext: 258,
        xResulttext: 570,  
        show_result: true
    },
    {
        label: 'Ruminococcus bromii',
        page: 11,
        yOffset: 467,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 459,
        yResult: 459,
        yResulttext: 463,
        xResulttext: 570,  
        show_result: true
    },
    {
        label: 'Staphylococcus aureus',
        page: 11,
        yOffset: 302,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 294,
        yResult: 294,
        yResulttext: 298,
        xResulttext: 570,  
        show_result: true
    },
    {
        label: 'Akkermansia muciniphila',
        page: 11,
        yOffset: 387,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 379,
        yResult: 379,
        yResulttext: 383,
        xResulttext: 570,  
        show_result: true
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 11,
        yOffset: 427,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 419,
        yResult: 419,
        yResulttext: 423,
        xResulttext: 570,  
        show_result: true
    },
    {
        label: 'Bifidobacterium bifidum',
        page: 11,
        yOffset: 556,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 548,
        yResult: 548,
        yResulttext: 552,
        xResulttext: 570,  
        show_result: true
    },
    {
        label: 'Bifidobacterium lactis',
        page: 11,
        yOffset: 596,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 588,
        yResult: 588,
        yResulttext: 592,
        xResulttext: 570,  
        show_result: true
    },
    {
        label: 'Lactobacillus acidophilus',
        page: 11,
        yOffset: 636,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 628,
        yResult: 628,
        yResulttext: 632,
        xResulttext: 570,  
        show_result: true
    },
    {
        label: 'Lactobacillus rhamnosus',
        page: 11,
        yOffset: 676,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 668,
        yResult: 668,
        yResulttext: 672,
        xResulttext: 570,  
        show_result: true
    },
    {
        label: 'Lactobacillus reuteri',
        page: 11,
        yOffset: 716,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 708,
        yResult: 708,
        yResulttext: 712,
        xResulttext: 570,  
        show_result: true
    },
    {
        label: 'Candida albicans',
        page: 15,
        yOffset: 143,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 135,
        yResult: 135,
        yResulttext: 137,
        xResulttext: 570,  
        show_result: false
    },
    {
        label: 'Escherichia coli',
        page: 15,
        yOffset: 333,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 324,
        yResult: 324,
        yResulttext: 326,
        xResulttext: 570,  
        show_result: false
    },
    {
        label: 'Staphylococcus aureus',
        page: 15,
        yOffset: 524,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 515,
        yResult: 515,
        yResulttext: 517,
        xResulttext: 570,  
        show_result: false
    },
    {
        label: 'Akkermansia muciniphila',
        page: 16,
        yOffset: 146,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 137,
        yResult: 137,
        yResulttext: 139,
        xResulttext: 570,  
        show_result: false
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 16,
        yOffset: 319,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 310,
        yResult: 310,
        yResulttext: 312,
        xResulttext: 570,  
        show_result: false
    },
    {
        label: 'Ruminococcus bromii',
        page: 16,
        yOffset: 555,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 546,
        yResult: 546,
        yResulttext: 548,
        xResulttext: 570,  
        show_result: false
    },
    {
        label: 'Bifidobacterium bifidum',
        page: 17,
        yOffset: 138,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 130,
        yResult: 130,
        yResulttext: 134,
        xResulttext: 570,  
        show_result: false
    },
    {
        label: 'Bifidobacterium lactis',
        page: 17,
        yOffset: 287,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 278,
        yResult: 278,
        yResulttext: 280,
        xResulttext: 570,  
        show_result: false
    },
    {
        label: 'Lactobacillus acidophilus',
        page: 17,
        yOffset: 539,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 530,
        yResult: 530,
        yResulttext: 532,
        xResulttext: 570,  
        show_result: false
    },
    {
        label: 'Lactobacillus rhamnosus',
        page: 17,
        yOffset: 714,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 705,
        yResult: 705,
        yResulttext: 707,
        xResulttext: 570,  
        show_result: false
    },
    {
        label: 'Lactobacillus reuteri',
        page: 17,
        yOffset: 971,
        xLabel: 70,
        xBarStart: 295,
        xBarGap: 53,
        xResult: 685,
        yLabel: 962,
        yResult: 962,
        yResulttext: 964,
        xResulttext: 570,  
        show_result: false
    },
    // {
    //     label: 'Candida albicans',
    //     page: 15,
    //     yOffset: 140,
    //     xLabel: 70,
    //     xBarStart: 295,
    //     xBarGap: 53,
    //     xResult: 685,
    //     yLabel: 130,
    //     yResult: 683,
    //     yResulttext: 134,
    //     xResulttext: 570,  
    //     show_result: false
    // },
    // {
    //     label: 'Escherichia coli',
    //     page: 15,
    //     yOffset: 330,
    //     xLabel: 70,
    //     xBarStart: 295,
    //     xBarGap: 53,
    //     xResult: 685,
    //     yLabel: 320,
    //     yResult: 683,
    //     yResulttext: 324,
    //     xResulttext: 570,  
    //     show_result: false
    // },
    // {
    //     label: 'Ruminococcus bromii',
    //     page: 15,
    //     yOffset: 518,
    //     xLabel: 70,
    //     xBarStart: 295,
    //     xBarGap: 53,
    //     xResult: 685,
    //     yLabel: 508,
    //     yResult: 683,
    //     yResulttext: 512,
    //     xResulttext: 570,  
    //     show_result: false
    // },
    // {
    //     label: 'Staphylococcus aureus',
    //     page: 15,
    //     yOffset: 660,
    //     xLabel: 70,
    //     xBarStart: 295,
    //     xBarGap: 53,
    //     xResult: 685,
    //     yLabel: 650,
    //     yResult: 683,
    //     yResulttext: 654,
    //     xResulttext: 570,  
    //     show_result: false
    // },
    // {
    //     label: 'Akkermansia muciniphila',
    //     page: 16,
    //     yOffset: 143,
    //     xLabel: 70,
    //     xBarStart: 295,
    //     xBarGap: 53,
    //     xResult: 685,
    //     yLabel: 133,
    //     yResult: 683,
    //     yResulttext: 137,
    //     xResulttext: 570,  
    //     show_result: false
    // },
    // {
    //     label: 'Faecalibacterium prausnitzii',
    //     page: 16,
    //     yOffset: 317,
    //     xLabel: 70,
    //     xBarStart: 295,
    //     xBarGap: 53,
    //     xResult: 685,
    //     yLabel: 307,
    //     yResult: 683,
    //     yResulttext: 311,
    //     xResulttext: 570,  
    //     show_result: false
    // },
    // {
    //     label: 'Bifidobacterium bifidum',
    //     page: 16,
    //     yOffset: 610,
    //     xLabel: 70,
    //     xBarStart: 295,
    //     xBarGap: 53,
    //     xResult: 685,
    //     yLabel: 600,
    //     yResult: 683,
    //     yResulttext: 604,
    //     xResulttext: 570,  
    //     show_result: false
    // },
    // {
    //     label: 'Bifidobacterium lactis',
    //     page: 16,
    //     yOffset: 760,
    //     xLabel: 70,
    //     xBarStart: 295,
    //     xBarGap: 53,
    //     xResult: 685,
    //     yLabel: 750,
    //     yResult: 683,
    //     yResulttext: 754,
    //     xResulttext: 570,  
    //     show_result: false
    // },
    // {
    //     label: 'Lactobacillus acidophilus',
    //     page: 17,
    //     yOffset: 110,
    //     xLabel: 70,
    //     xBarStart: 295,
    //     xBarGap: 53,
    //     xResult: 685,
    //     yLabel: 100,
    //     yResult: 683,
    //     yResulttext: 104,
    //     xResulttext: 570,  
    //     show_result: false
    // },
    // {
    //     label: 'Lactobacillus rhamnosus',
    //     page: 17,
    //     yOffset: 300,
    //     xLabel: 70,
    //     xBarStart: 295,
    //     xBarGap: 53,
    //     xResult: 685,
    //     yLabel: 290,
    //     yResult: 683,
    //     yResulttext: 294,
    //     xResulttext: 570,  
    //     show_result: false
    // },
    // {
    //     label: 'Lactobacillus reuteri',
    //     page: 17,
    //     yOffset: 560,
    //     xLabel: 70,
    //     xBarStart: 295,
    //     xBarGap: 53,
    //     xResult: 685,
    //     yLabel: 550,
    //     yResult: 683,
    //     yResulttext: 554,
    //     xResulttext: 570,  
    //     show_result: false
    // }
];